import { createSlice } from "@reduxjs/toolkit";

const initialKotaState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  kotaForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const kotaSlice = createSlice({
  name: "kota",
  initialState: initialKotaState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    kotaFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    kotaAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    kotaCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.kota.push(action.payload.kota);
    },
    kotaDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.kota.filter(
        (el) => el.kota_id !== action.payload.id
      );
    },
    getKota: (state, action) => {
      state.actionsLoading = false;
      state.kotaForEdit = action.payload.kotaForEdit;
      state.error = null;
    },
    // updateProduct
    kotaUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.kota = state.entities.kota.map((entity) => {
        if (entity.kota_id === action.payload.kota.kota_id) {
          return action.payload.kota;
        }
        return entity;
      });
    },
  },
});
